import * as marketingButtonStyles from "../../../styles/internal-page/marketing-button.module.scss";

import {GatsbyImage, getImage} from "gatsby-plugin-image";

import IconContainer from "../IconContainer";
import React from "react";
import PolyLink from "../PolyLink";
import {altNN} from "../../../utils/parsing";
import clsx from "clsx";

const Marketing = ({
    link, text, link_label, height, image, icon, color,
}) => {

    const [isHovered, setIsHovered] = React.useState(false);
    let hoveredColor = color === "DARK_RED" ? "#671f2b" : "var(--red-color)";
    const key = `${link}${text}${link_label}${height}${color}`
    const myFirstId = `${key}-first`
    const mySecondId = `${key}-second`

    const [firstEl, setFirstEl] = React.useState(null);
    const [secondEl, setSecondEl] = React.useState(null);

    React.useEffect(() => {
        if (typeof window != 'undefined' && window.document) {
            let firstElement = document.getElementById(myFirstId)
            let secondElement = document.getElementById(mySecondId)
            setFirstEl(firstElement)
            setSecondEl(secondElement)
        }
    }, [myFirstId, mySecondId])


    const gridInsideRenderer = () => {
        return (<>
            <div
                className={marketingButtonStyles.absolute}
            >
                <div className={marketingButtonStyles.rootContainer}>
                    <div className={marketingButtonStyles.rootContainerChild}>
                        <div className={marketingButtonStyles.itemContainer}>
                            <IconContainer icon={icon} color="WHITE" variant="full" size="25"/>
                        </div>
                        <div className={marketingButtonStyles.link}>
                            <p
                                className={clsx(marketingButtonStyles.h3Text, marketingButtonStyles.text)}
                            >
                                {text}
                            </p>

                            <div
                                className={marketingButtonStyles.margin}
                            >
                  <span
                      className={marketingButtonStyles.subText}
                  >
                    {link_label}
                  </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>)
    }

    const gridRenderer = () => {
        return (<>
            <div id={myFirstId}
                 className={clsx({[marketingButtonStyles.displayMarketing]: firstEl && firstEl.closest('a')}, marketingButtonStyles.blocPrincipal, marketingButtonStyles.blocToHover)}
                 style={{height: height}}
            >
                <div
                    className={marketingButtonStyles.hoveredBloc}
                    style={{backgroundColor: hoveredColor}}
                ></div>
                <GatsbyImage
                    image={getImage(image?.imageFile)}
                    className={marketingButtonStyles.imgWrapper}
                    alt={image?.alternativeText}
                ></GatsbyImage>
                {gridInsideRenderer()}
            </div>
            <button id={mySecondId} tabIndex={0}
                 className={clsx({[marketingButtonStyles.hideMarketing]: !secondEl || (secondEl && secondEl.closest('a'))}, marketingButtonStyles.blocPrincipal)}
                 style={{height: height}}
                 onMouseEnter={() => setIsHovered(true)}
                 onMouseLeave={() => setIsHovered(false)}
            >
                {isHovered ? (<div
                    className={marketingButtonStyles.hoveredBloc}
                    style={{backgroundColor: hoveredColor}}
                ></div>) : (<GatsbyImage
                    image={getImage(image?.imageFile)}
                    className={marketingButtonStyles.imgWrapper}
                    alt={altNN(image?.alternativeText)}
                ></GatsbyImage>)}
                {gridInsideRenderer()}
            </button>
        </>)
    }

    return (<PolyLink
        className={marketingButtonStyles.bloc}
        url={link}
        target="_blank"
    >
        {gridRenderer()}
    </PolyLink>);
};

export default Marketing;
